// extracted by mini-css-extract-plugin
module.exports = {"root":"pZYff","left":"_32fu2","label":"_3CkAi","right":"rLtWm"};